<script setup lang="ts">
import { User, UserInfoGraphic } from '@/models/user.model';
import { ShiftCMSState } from '@/store';
import { UsersActions, UsersState } from '@/stores/users.store';
import { computed, PropType } from 'vue';
import { useStore } from 'vuex';

const props = defineProps({
  user: {
    type: Object as PropType<User>,
    required: true,
  },
});

const store = useStore<ShiftCMSState & { us: UsersState }>();

const infographics = computed<UserInfoGraphic[]>(
  () => store.state.us.userInfoGraphics,
);

const headers = [
  { title: 'Infographic', key: 'infographic.title' },
  { title: 'Options', key: 'options' },
];

function deleteUserInfoGraphic(id: number) {
  store.dispatch(UsersActions.DeleteUserInfoGraphic, {
    id,
    userId: props.user.id,
  });
}
</script>
<template>
  <v-card class="mt-4">
    <v-card-title>Infographics</v-card-title>

    <v-data-table
      density="compact"
      :headers="headers"
      :items="infographics"
      itemsPerPage="10"
      hover
    >
      <template v-slot:item.options="{ item }">
        <v-btn
          density="compact"
          icon="mdi-delete-outline"
          @click="deleteUserInfoGraphic(item.id)"
        /> </template
    ></v-data-table>
  </v-card>
</template>
